import styled from 'styled-components';

export type ToggleProps = {
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
  onClick: (e: React.MouseEvent) => void;
  'aria-label': string;
};

const Toggle = ({
  checked,
  disabled,
  onChange,
  onClick,
  'aria-label': ariaLabel,
}: ToggleProps) => (
  <ToggleTrack
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    aria-disabled={disabled}
    $checked={checked}
    $disabled={!!disabled}
    onClick={(e) => {
      onClick(e);
      if (!disabled) onChange();
    }}
    onKeyDown={(e) => {
      if (disabled) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onChange();
      }
    }}
    tabIndex={disabled ? -1 : 0}
  >
    <ToggleThumb $checked={checked} $disabled={!!disabled} />
  </ToggleTrack>
);

export default Toggle;

const ToggleTrack = styled.span<{ $checked: boolean; $disabled: boolean }>`
  display: block;
  position: relative;
  width: 44px;
  height: 24px;
  padding: 2px;
  border-radius: 9999px;
  border: 1px solid ${({ theme }) => theme.colors.white};
  background: ${({ theme, $checked, $disabled }) =>
    $disabled
      ? theme.colors.greyDisabled2
      : $checked
        ? theme.colors.colorMain
        : theme.colors.greyDisabled2};
  flex-shrink: 0;
  transition: background 0.2s ease;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.7 : 1)};
  box-sizing: border-box;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.white};
    outline-offset: 2px;
  }
`;

const ToggleThumb = styled.span<{ $checked: boolean; $disabled: boolean }>`
  position: absolute;
  top: 50%;
  left: ${({ $checked }) => ($checked ? '20px' : '2px')};
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 9999px;
  background: ${({ theme }) => theme.colors.white};
  transition:
    left 0.2s ease,
    background 0.2s ease;
  transform: translateY(-50%);
`;
